import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentRequest } from '../../shared/models/appointment-request.model';

@Pipe({
  name: 'appointmentRequestDescription',
})
export class AppointmentRequestDescriptionPipe implements PipeTransform {
  transform(value: AppointmentRequest) : string {
    if (value.task) {
      return value.task.description;
    } else {
      return value.reason.description;
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/appointment-request-description.pipe.ts